import { render, staticRenderFns } from "./NoticeAdmin.vue?vue&type=template&id=76efc1b3&scoped=true"
import script from "./NoticeAdmin.vue?vue&type=script&lang=js"
export * from "./NoticeAdmin.vue?vue&type=script&lang=js"
import style0 from "./NoticeAdmin.vue?vue&type=style&index=0&id=76efc1b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76efc1b3",
  null
  
)

export default component.exports